import { createTheme } from '@mui/material/styles';
import { palette } from './definitions';
import getContrastText from '../utils/getContrastColor';
export const themeConstructorV2 = (primaryColor, fontFamily, dark) => {
  const font = fontFamily || '"CircularStd", Arial, sans-serif';
  return createTheme({
    components: {
      MuiPopover: {
        styleOverrides: {
          root: {
            zIndex: 1301,
          },
        },
      },
      MuiButton: {
        variants: [
          {
            props: {
              variant: 'contained',
            },
            style: {
              textTransform: 'initial',
              borderRadius: '50px',
              fontSize: '14px',
              fontWeight: 700,
            },
          },
          {
            props: {
              variant: 'outlined',
              color: 'text',
            },
            style: {
              textTransform: 'initial',
              borderRadius: '50px',
              fontSize: '14px',
              fontWeight: 700,
            },
          },
        ],
      },
      MuiAlert: {
        variants: [
          {
            props: {
              severity: 'error',
            },
            style: {
              border: `1px solid ${palette.error.main}`,
            },
          },
          {
            props: {
              severity: 'success',
            },
            style: {
              border: `1px solid ${palette.success.main}`,
            },
          },
          {
            props: {
              severity: 'warning',
            },
            style: {
              border: `1px solid ${palette.warning.main}`,
            },
          },
          {
            props: {
              severity: 'info',
            },
            style: {
              border: `1px solid ${palette.info.main}`,
            },
          },
        ],
      },
      MuiAutocomplete: {
        styleOverrides: {
          option: {
            padding: '8px'
          },
          noOptions: {
            padding: '8px'
          }
        }
      },
      MuiIconButton: {
        variants: [
          {
            props: {
              color: 'default',
              size: 'medium',
            },
            style: {
              width: '32px',
              height: '32px',
              color: palette.text.lightish,
              border: `1px solid ${palette.common.outline}`,
              '&>svg': {
                fontSize: '16px',
              },
            },
          },
          {
            props: {
              color: 'error',
              size: 'medium',
            },
            style: {
              width: '32px',
              height: '32px',
              color: palette.text.lightish,
              border: `1px solid ${palette.common.outline}`,
              '&:hover': {
                color: palette.error.main,
              },
              '&>svg': {
                fontSize: '16px',
              },
            },
          },
        ],
      },
    },
    palette: {
      ...palette,
      hoverColor: primaryColor,
      primary: {
        main: primaryColor,
      },
      secondary: {
        main: primaryColor,
      },
      accent: {
        main: primaryColor || palette.accent.main,
        contrastText: primaryColor ? getContrastText(primaryColor) : palette.accent.contrastText,
      },
      type: dark ? 'dark' : 'light',
      background: {
        paper: dark ? '#424242' : '#fff',
        default: dark ? '#303030' : '#fafafa',
      },
    },
    typography: {
      fontFamily: font,
      fontSize: 16,
      htmlFontSize: 16,
      fontWeight: 300,
      h1: {
        fontSize: '19px',
        fontWeight: 500,
        fontFamily: font,
      },
      h2: {
        fontSize: '17px',
        fontWeight: 500,
        fontFamily: font,
      },
      body1: {
        fontSize: '16px',
        fontFamily: font,
        fontWeight: 300
      },
      body2: {
        fontSize: '14px',
        fontFamily: font,
        fontWeight: 300
      },
    },
    transitions: {
      duration: {
        shortest: 150,
        shorter: 200,
        short: 250,
        // most basic recommended timing
        standard: 300,
        // this is to be used in complex animations
        complex: 375,
        // recommended when something is entering screen
        enteringScreen: 225,
        // recommended when something is leaving screen
        leavingScreen: 195,
      },
    },
  });
};
